import React, { useState } from 'react'
import Select from 'react-select'
import theme from './filter.theme'

import {
  getIsPriceFilter,
  MAX_OPTIONS_TO_FILTER,
  ADVICE_MESSAGE_SHOW_WHEN_MAX_OPTIONS_TO_FILTER,
  ADVICE_MESSAGE_SHOW_WHEN_MAX_OPTIONS_TO_PRICE_FILTER,
} from '../../domains/filters'
import styles from './filter.module.css'

const Filter = (props) => {
  const { filter, disabled, onChange } = props

  const [areOptionsDisabled, setAreOptionsDisabled] = useState(false)
  const isPriceFilter = getIsPriceFilter(filter.type)

  const handleChange = (options) => {
    if (onChange) {
      onChange(filter.type, options)
    }

    if (isPriceFilter && options?.length === MAX_OPTIONS_TO_FILTER - 1) {
      setAreOptionsDisabled(true)
      return
    } else if (!isPriceFilter && options?.length > MAX_OPTIONS_TO_FILTER - 1) {
      setAreOptionsDisabled(true)
      return
    }

    setAreOptionsDisabled(false)
  }

  const showOptionsDisabled = areOptionsDisabled && !isPriceFilter
  const showPriceOptionsDisabled = areOptionsDisabled && isPriceFilter

  return (
    <section className={styles.filter}>
      <Select
        styles={theme}
        placeholder={filter.placeholder}
        options={filter.options}
        name={filter.type}
        isSearchable
        isMulti
        isOptionDisabled={() => areOptionsDisabled}
        isDisabled={disabled}
        onChange={handleChange}
      />
      <footer className={styles.footer}>
        <p
          className={`${styles.advice} ${
            areOptionsDisabled ? styles.show : null
          }`}
        >
          {showOptionsDisabled &&
            ADVICE_MESSAGE_SHOW_WHEN_MAX_OPTIONS_TO_FILTER}
          {showPriceOptionsDisabled &&
            ADVICE_MESSAGE_SHOW_WHEN_MAX_OPTIONS_TO_PRICE_FILTER}
        </p>
      </footer>
    </section>
  )
}

export default Filter
